import angular from 'angular';

module.exports = angular.module('market.routes.humans', [
  require('./account'),
  require('./login'),
  require('./register'),
])
.config(function($stateProvider) {
  $stateProvider.state('humans', {
    parent: 'root',
    abstract: true,
    views: {
      '': {
        template: '<div ui-view></div>'
      },
      'footer@': { template: '<div></div>' } // disable footer
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/humans/index.js
 **/